<template>
  <v-container
    class="pa-0 py-md-2"
    style="max-width: 800px;"
  >
    <v-toolbar
      flat
      class="mb-n1"
    >
      <v-btn
        icon
        :to="$route.query.backLink"
      >
        <v-icon>{{ mdiArrowLeft }}</v-icon>
      </v-btn>
      <v-toolbar-title>
        {{ $t('Workflow.GeneralProgress') }}
      </v-toolbar-title>
    </v-toolbar>
    <!-- <v-subheader v-if="userRecords">
      {{ $t('eLeave.ApplyALOrAbsence') }}
    </v-subheader> -->

    <v-data-iterator
      :items="userRecords"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="searchText"
      :loading="loading"
      hide-default-footer
    >
      <!-- <template v-slot:header>
        <v-toolbar flat>
          <v-text-field
            v-model="searchText"
            clearable
            flat
            solo
            background-color="grey lighten-3"
            hide-details
            prepend-inner-icon="mdi-magnify"
            :label="$t('PublicServant.Action.Search')"
          />
        </v-toolbar>
      </template> -->

      <template v-slot:default="props">
        <v-card
          v-for="(item) in props.items"
          :key="item.formCode"
          class="mb-1"
          flat
        >
          <v-card-text>
            <div>
              {{ $chPtObjData('chinTaskListDesc1', item) }}
              <v-btn
                v-if="$config.isBrowser && showDownloadButton(item)"
                icon
                large
                class="float-right"
                :loading="downloadLoading"
                @click="downloadFile(item.formCode)"
              >
                <v-icon color="deep-orange lighten-2">
                  {{ mdiFileDownloadOutline }}
                </v-icon>
              </v-btn>
            </div>
            <div class="v-list-item__title text--primary">
              {{ $chPtObjData('chinTaskListTitle', item) }}
            </div>
            <div
              v-if="item.workflowStatusList[0]"
              class="d-flex"
            >
              <div>
                <p>{{ $chPtObjData('chinTaskListDesc2', item) }}</p>
                <div
                  class="d-inline-block px-3 py-2 grey lighten-4 text--primary"
                >
                  <span class="font-weight-light mr-2">
                    <template v-if="item.workflowStatusList[0].completedTime">{{ momentWithHyphen(item.workflowStatusList[0].completedTime).format('YYYY-MM-DD HH:mm') }}</template>
                    <template v-else-if="item.workflowStatusList[0].initiatedTime">{{ momentWithHyphen(item.workflowStatusList[0].initiatedTime).format('YYYY-MM-DD HH:mm') }}</template>
                  </span>
                  <span v-show="item.workflowStatusList[0].status === 'A'">{{ $t('TaskList.Waiting') }}</span>
                  {{ $chPtObjData('chinStaffName', item.workflowStatusList[0]) }}
                  {{ $chPtObjData('chinWorkflowStatusDesc', item.workflowStatusList[0]) }}
                  <s-detail-button :item="item" />
                </div>
              </div>
              <v-spacer />
              <div class="text-right">
                <!-- recreate -->
                <v-tooltip
                  v-if="showRecreate(item)"
                  top
                  color="black"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      color="grey darken-3"
                      v-bind="attrs"
                      v-on="on"
                      @click="recreateJob(recreateJobCb, item.formIdentity)"
                    >
                      <v-icon>
                        {{ mdiBackupRestore }}
                      </v-icon>
                      <!-- <span class="d-none d-md-inline-block">{{ $t('TaskList.Recreate') }}</span> -->
                    </v-btn>
                  </template>
                  <span>{{ $t('TaskList.Recreate') }}</span>
                </v-tooltip>

                <v-tooltip
                  top
                  color="black"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-show="item.attachmentList.length > 0 && !$config.isApp"
                      icon
                      color="grey darken-3"
                      v-bind="attrs"
                      v-on="on"
                      @click="downloadAttachmentOrOficio(item)"
                    >
                      <v-icon>{{ mdiFileDownloadOutline }}</v-icon>
                      <!-- <span class="d-none d-md-inline-block">{{ $t('Outbox.DownloadPresentFile') }}</span> -->
                    </v-btn>
                  </template>
                  <span v-if="item.businessCode === OFICIO">{{ $t('Outbox.DownloadPresentFile') }}</span>
                  <span v-else>{{ $t('Outbox.Attachment') }}</span>
                </v-tooltip>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </template>

      <template v-slot:footer="props">
        <v-pagination
          v-if="props.pagination.pageCount"
          v-model="page"
          :length="props.pagination.pageCount"
          circle
        />
      </template>

      <template v-slot:no-data>
        <v-card
          flat
          class="mt-2 py-6"
        >
          <v-card-text class="text-body-1 black--text">
            {{ $t('PublicServant.NoData') }}
          </v-card-text>
        </v-card>
      </template>

      <template v-slot:no-results>
        <v-card
          flat
          class="mt-2 py-6"
        >
          <v-card-text class="text-body-1 black--text">
            {{ $t('PublicServant.NoData') }}
          </v-card-text>
        </v-card>
      </template>

      <template v-slot:loading>
        <v-skeleton-loader
          class="mb-6"
          type="list-item-avatar-three-line, divider, list-item-avatar-three-line"
        />
      </template>
    </v-data-iterator>
    <p class="px-4 text-caption grey--text">
      *{{ $t('Workflow.OnlyShowXMonths', {'0': '3'}) }}
    </p>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import SDetailButton from './components/List/SDetailButton'
import { staffModule, workflowModule } from '../../store/moduleName'
import workflowApi from '../../api/workflow/workflow'
import { downloadMethod } from '@/mixins/downloadMethod'
import { momentWithHyphen } from '@/utils/datetimeUtil'
import { mdiArrowLeft, mdiFileDownloadOutline, mdiBackupRestore } from '@mdi/js'
import { BUSINESS_CODE } from '@/constant/constant'
import outboxApi from '@/api/outbox/outbox'
import { eLeaveMethod } from '@/views/Eleave/mixins/eLeaveMethod'

export default {
  components: {
    SDetailButton
  },
  mixins: [eLeaveMethod, downloadMethod],
  // props: example: this.$route.query = { "showEndTask": true, "businessCodes": "ofc", "backLink": "/outbox/Create" }

  data: function () {
    return {
      // requestBody: [],
      mdiArrowLeft: mdiArrowLeft,
      mdiFileDownloadOutline: mdiFileDownloadOutline,
      mdiBackupRestore,
      userRecords: [],
      loading: false,
      itemsPerPage: 10,
      page: 1,
      searchText: null, // No using now, can un-comments above html code to active it,
      downloadLoading: false,
      OFICIO: BUSINESS_CODE.OFICIO
    }
  },
  computed: {
    numberOfPages () {
      return Math.ceil(this.userRecords.length / this.itemsPerPage)
    },
    ...mapState({
      staff: state => state[staffModule].info,
      business: state => state[workflowModule].items,
      progressOption: state => state[workflowModule].progressOption
    })
  },
  async created () {
    this.loading = true
    if (!this.staff) {
      await this.$store.dispatch(staffModule + '/getStaff')
    }

    // this.requestBody[0] = BUSINESS_CODE.ELEAVE_FERIAS
    // this.requestBody[1] = BUSINESS_CODE.ELEAVE_FALTA
    let cb = resp => {
      this.userRecords = resp.data
      this.userRecords.sort((a, b) => {
        return b.id - a.id
      })
    }

    let businessCodes = this.$route.query.businessCodes
    if (!(businessCodes instanceof Array)) {
      businessCodes = businessCodes.split() // String to Array
    }

    if (this.$route.query.showEndTask) {
      await workflowApi.personalFormsAndWorkflowStatus(cb, businessCodes)
    } else {
      await workflowApi.getPersonalActiveFormsWorkflowStatus(cb, businessCodes)
    }

    this.userRecords.forEach(record => {
      record.workflowStatusList.reverse()
    })

    this.loading = false
  },
  methods: {
    showRecreate (item) {
      return (item.businessCode === BUSINESS_CODE.OFICIO) && (item.statusCode === 'C')
    },
    recreateJob (cb, oficioId) {
      outboxApi.getOficioById(oficioId, resp => {
        if (resp.status === 201 || resp.status === 200) {
          cb(resp.data)
        }
      })
    },
    recreateJobCb (data) {
      this.$router.push({ name: 'OutboxCreate', params: { prefilledForm: data } })
    },
    search () {
      this.searchForm.entityId = this.staff.entityId
      workflowApi.searchForms(cb => {
        this.tableData = cb.data
        this.loading = false
      }, this.searchForm)
    },
    showDownloadButton (item) {
      return (item.businessCode !== BUSINESS_CODE.OFICIO && item.businessCode !== BUSINESS_CODE.TRAINING && item.formCode && !item.formCode.startsWith('000'))
    },
    downloadAttachmentOrOficio (item) {
      if (item.businessCode === BUSINESS_CODE.OFICIO) {
        this.downloadAttachments(item)
      } else {
        this.downloadELeaveAttachments(item.formCode)
      }
    },
    momentWithHyphen: momentWithHyphen
    // downloadAttachmentsZip (item) {
    //   this.downloadZip(OUTBOX_FILE_TYPE.ATTACHMENT, item.attachmentList[0].formAttributeId, item.attachmentList[0].workItemId)
    // }
    // downloadReferenceZip (item) {
    //   this.downloadZip(OUTBOX_FILE_TYPE.REFERENCE, item.attachmentList[0].formAttributeId, item.attachmentList[0].workItemId)
    // },
    // downloadOficioDoc (item) {
    //   outboxApi.downloadFile(resp => {
    //     if (resp.status === 201 || resp.status === 200) {
    //       const url = window.URL.createObjectURL(new Blob([resp.data]))
    //       const link = document.createElement('a')
    //       link.href = url
    //       link.setAttribute('download', item.mainDocument.fileName)
    //       link.click()
    //       window.URL.revokeObjectURL(url)
    //     }
    //   }, item.mainDocument.documentId)
    // }
  }
}
</script>
